import React from 'react';
import PropTypes from 'prop-types';
import RenderTextInputField from 'components/form/InputFields/RenderTextInputField';
import SubmitButton from 'components/button/SubmitButton';
import compose from 'recompose/compose';
import translate from 'components/hoc/translate';
import validations from 'helpers/forms/validations';
import { ButtonWrapper, FormWrapper, Item, Row, Section } from 'components/ui/table/elements';
import { Field, reduxForm } from 'redux-form';
import ArrayConfiguration from 'pages/products/configuration/ArrayConfiguration';
import TimeTableCell from 'pages/products/configuration/TimeTableCell';
import SelectInputTableCell from 'pages/products/configuration/SelectInputTableCell';
import utils from 'helpers/utils';
import RenderBooleanInputField from 'components/form/InputFields/RenderBooleanInputField';
import { range } from 'lodash';

class MembershipScheduleCreateForm extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            entries: [],
            errors: {},
        };
    }

    componentDidMount() {
        const { initialValues } = this.props;

        if (initialValues && initialValues.entries.length > 0) {
            this.setState({
                entries: this.transformScheduleEntries(initialValues.entries),
            });
        }
    }

    transformScheduleEntries = (newEntries) => {
        return newEntries.map((entry) => {
            return {
                id: utils.uuid(),
                from: entry.starts_at,
                to: entry.ends_at,
                weekday: entry.day,
            };
        });
    }

    onAddRangeByKey = () => {
        const { entries } = this.state;

        this.setState({
            entries: [
                ...entries || [],
                {
                    id: utils.uuid(),
                    from: '00:00',
                    to: '23:59',
                    weekday: null,
                },
            ],
        });
    }

    onChangeRangeByKey = (event, scheduleElement) => {
        const { entries } = this.state;
        const value = event.target.value;
        const name = event.target.name;
        const { id } = scheduleElement;

        const updatedSchedule = entries.map((scheduleValue) => {
            if (scheduleValue.id === id) {
                return { ...scheduleValue, [name]: value };
            }

            return scheduleValue;
        });

        this.setState({
            entries: [
                ...updatedSchedule,
            ],
        });
    }

    onDeleteRangeByKey = (id) => {
        const { entries } = this.state;

        const updatedSchedule = entries.filter((scheduleValue) => {
            return scheduleValue.id !== id;
        });

        this.setState({
            entries: [
                ...updatedSchedule,
            ],
        });
    }

    isEmptyEntry = (entry) => {
        const { from, to, weekday } = entry;

        return !from || !to || !weekday;
    };

    handleTransformPayload = (oldEntries) => {
        const newEntries = oldEntries
            .map((oldEntry) => {
                if (this.isEmptyEntry(oldEntry)) {
                    return null;
                }

                return {
                    day: oldEntry.weekday,
                    starts_at: oldEntry.from,
                    ends_at: oldEntry.to,
                };
            })
            .filter((entry) => {
                return entry !== null;
            });

        return newEntries;
    };

    onSubmit = (data) => {
        const { entries } = this.state;
        const payloadEntries = this.handleTransformPayload(entries);

        this.props.handleSubmitForm({
            ...data,
            entries: payloadEntries,
        });
    };

    render() {
        const {
            handleSubmit,
            submitting,
            translate,
        } = this.props;

        return (
            <FormWrapper>
                <form onSubmit={ handleSubmit(this.onSubmit) }>
                    <Section>
                        <Row>
                            <Item>
                                <Field
                                    component={ RenderTextInputField }
                                    fullWidth={ false }
                                    label={ translate('filters.components.name.label') }
                                    name='name'
                                    validate={ validations.required }
                                />
                            </Item>
                        </Row>
                        <Row>
                            <Item>
                                <Field
                                    component={ RenderBooleanInputField }
                                    label={ translate('resources.products.fields.is_visible') }
                                    name='is_visible'
                                />
                            </Item>
                        </Row>
                    </Section>

                    <Section>
                        <ArrayConfiguration
                            component={ TimeTableCell }
                            components={ {
                                weekday: <SelectInputTableCell choices={ range(0, 8).map((value) => {
                                    return {
                                        text: value ? translate(`fields.weekday.${ value }`) : '',
                                        value: value || null,
                                    };
                                }) } />,
                            } }
                            errors={ this.state.errors }
                            fields={ [
                                'from',
                                'to',
                                'weekday',
                            ] }
                            id='table-schedule'
                            name='entries'
                            onAdd={ this.onAddRangeByKey }
                            onChange={ this.onChangeRangeByKey }
                            onDelete={ this.onDeleteRangeByKey }
                            values={ this.state.entries }
                            showTitle={ false }
                        />
                    </Section>

                    <Section>
                        <Row>
                            <ButtonWrapper>
                                <SubmitButton loading={ submitting } />
                            </ButtonWrapper>
                        </Row>
                    </Section>
                </form>
            </FormWrapper>
        );
    }
}

MembershipScheduleCreateForm.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    handleSubmitForm: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,
    translate: PropTypes.func.isRequired,
    initialValues: PropTypes.shape({
        entries: PropTypes.array,
    }),
};

const enhance = compose(
    translate,
    reduxForm({
        validate: (values, props) => {
            const errors = {};
            const { translate } = props;

            if (!values.name) {
                errors.name = translate('forms.required');
            }

            return errors;
        },
    }),
);

export default enhance(MembershipScheduleCreateForm);


// WEBPACK FOOTER //
// ./src/pages/membership-schedules/create/MembershipScheduleCreateForm.js